import React from "react";
import { motion } from "framer-motion";
import "./statsSection.css";
import FeatureIcon from "../Features/FeatureIcon";

const StatsSection = () => {
  const stats = [
    {
      icon: "people",
      value: "400+",
      label: "Verified KOLs",
      delay: 0.1,
    },
    {
      icon: "globe",
      value: "Global",
      label: "Reach",
      delay: 0.2,
    },
    {
      icon: "clock",
      value: "24/7",
      label: "Support",
      delay: 0.3,
    },
    {
      icon: "shield",
      value: "100%",
      label: "Verified",
      delay: 0.4,
    },
  ];

  return (
    <section className="stats-section">
      <div className="stats-container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-card"
              initial={{ opacity: 1, y: 0, scale: 1 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.3, delay: stat.delay }}
              whileHover={{ 
                y: -8,
                scale: 1.02,
                transition: { duration: 0.2 }
              }}
            >
              {/* Icon with Gradient Background */}
              <div className="stat-icon-wrapper">
                <FeatureIcon type={stat.icon} />
              </div>
              
              {/* Large Value */}
              <h3 className="stat-value">{stat.value}</h3>
              
              {/* Descriptive Label */}
              <p className="stat-label">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;



